module.exports = tribe.common.data.plugins;